var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSiteFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 673,
    height: 201,
    viewBox: "0 0 673 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_253_1252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.793 182.891H224.64V184.569H216.848V190.311H223.129V191.989H216.848V198.11H225.065V199.787H214.793V182.891Z",
    fill: "url(#paint0_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.514 200C255.42 200 253.862 199.512 252.838 198.535C251.831 197.542 251.241 196.243 251.067 194.636H253.051C253.13 195.187 253.24 195.668 253.382 196.077C253.539 196.487 253.775 196.873 254.09 197.235C254.421 197.598 254.869 197.873 255.436 198.062C256.003 198.251 256.695 198.346 257.514 198.346C258.616 198.346 259.529 198.054 260.253 197.472C260.993 196.873 261.363 196.101 261.363 195.156C261.363 194.179 261.072 193.454 260.489 192.982C259.923 192.509 258.852 192.155 257.278 191.918C255.373 191.619 253.956 191.131 253.027 190.453C252.099 189.76 251.634 188.697 251.634 187.263C251.634 185.955 252.146 184.868 253.169 184.002C254.192 183.12 255.491 182.679 257.065 182.679C258.766 182.679 260.112 183.08 261.103 183.884C262.111 184.672 262.701 185.822 262.874 187.334H261.033C260.828 186.263 260.411 185.499 259.781 185.042C259.167 184.569 258.262 184.333 257.065 184.333C255.932 184.333 255.058 184.585 254.444 185.089C253.846 185.577 253.547 186.239 253.547 187.074C253.547 187.956 253.814 188.626 254.35 189.083C254.885 189.524 255.971 189.862 257.608 190.099C259.592 190.398 261.04 190.918 261.953 191.658C262.882 192.383 263.347 193.502 263.347 195.014C263.347 196.432 262.788 197.621 261.67 198.582C260.568 199.527 259.183 200 257.514 200Z",
    fill: "url(#paint1_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.755 182.891H295.548C297.28 182.891 298.697 183.301 299.799 184.12C300.901 184.924 301.452 186.16 301.452 187.83V187.925C301.452 189.626 300.901 190.886 299.799 191.706C298.713 192.509 297.296 192.911 295.548 192.911H292.809V199.787H290.755V182.891ZM295.69 191.28C296.902 191.28 297.823 190.997 298.453 190.43C299.083 189.847 299.398 189.012 299.398 187.925V187.83C299.398 185.64 298.162 184.545 295.69 184.545H292.809V191.28H295.69Z",
    fill: "url(#paint2_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.9 198.299C337.757 198.299 339.229 197.661 340.315 196.384C341.417 195.108 341.968 193.439 341.968 191.375V191.186C341.968 189.232 341.417 187.602 340.315 186.294C339.213 184.987 337.726 184.333 335.852 184.333C333.932 184.333 332.42 184.971 331.318 186.247C330.216 187.507 329.665 189.169 329.665 191.233V191.422C329.665 193.439 330.256 195.093 331.436 196.384C332.633 197.661 334.121 198.299 335.9 198.299ZM335.9 200C333.444 200 331.436 199.181 329.878 197.542C328.319 195.888 327.54 193.856 327.54 191.446V191.257C327.54 188.815 328.311 186.775 329.854 185.136C331.413 183.498 333.412 182.679 335.852 182.679C338.292 182.679 340.276 183.498 341.803 185.136C343.33 186.759 344.094 188.783 344.094 191.209V191.398C344.094 193.824 343.33 195.865 341.803 197.519C340.276 199.173 338.308 200 335.9 200Z",
    fill: "url(#paint3_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.421 182.891H376.498C378.245 182.891 379.662 183.277 380.748 184.049C381.85 184.821 382.401 186.003 382.401 187.594V187.688C382.401 188.996 382.016 190.036 381.244 190.808C380.473 191.564 379.465 192.06 378.222 192.296L383.393 199.787H381.102L376.073 192.438H373.475V199.787H371.421V182.891ZM376.639 190.808C379.111 190.808 380.347 189.768 380.347 187.688V187.594C380.347 186.491 380.032 185.711 379.402 185.254C378.773 184.782 377.852 184.545 376.639 184.545H373.475V190.808H376.639Z",
    fill: "url(#paint4_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.265 184.569H408.353V182.891H420.231V184.569H415.319V199.787H413.265V184.569Z",
    fill: "url(#paint5_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.053 200C449.959 200 448.401 199.512 447.378 198.535C446.37 197.542 445.78 196.243 445.606 194.636H447.59C447.669 195.187 447.779 195.668 447.921 196.077C448.078 196.487 448.314 196.873 448.629 197.235C448.96 197.598 449.408 197.873 449.975 198.062C450.542 198.251 451.234 198.346 452.053 198.346C453.155 198.346 454.068 198.054 454.792 197.472C455.532 196.873 455.902 196.101 455.902 195.156C455.902 194.179 455.611 193.454 455.028 192.982C454.462 192.509 453.391 192.155 451.817 191.918C449.912 191.619 448.495 191.131 447.566 190.453C446.638 189.76 446.173 188.697 446.173 187.263C446.173 185.955 446.685 184.868 447.708 184.002C448.731 183.12 450.03 182.679 451.604 182.679C453.305 182.679 454.651 183.08 455.642 183.884C456.65 184.672 457.24 185.822 457.413 187.334H455.572C455.367 186.263 454.95 185.499 454.32 185.042C453.706 184.569 452.801 184.333 451.604 184.333C450.471 184.333 449.597 184.585 448.983 185.089C448.385 185.577 448.086 186.239 448.086 187.074C448.086 187.956 448.354 188.626 448.889 189.083C449.424 189.524 450.51 189.862 452.148 190.099C454.131 190.398 455.579 190.918 456.492 191.658C457.421 192.383 457.886 193.502 457.886 195.014C457.886 196.432 457.327 197.621 456.209 198.582C455.107 199.527 453.722 200 452.053 200Z",
    fill: "url(#paint6_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.403 150.378C333.744 150.378 320.929 145.966 311.851 137.251C302.881 128.536 298.396 115.733 298.396 98.9486V21.4825H327.123V97.1196C327.123 107.879 328.938 115.625 332.462 120.359C336.093 125.093 342.073 127.46 350.51 127.46C359.053 127.46 365.247 125.093 369.092 120.359C372.936 115.625 374.858 107.556 374.858 96.0437V21.4825H403.585V97.7651C403.585 114.98 398.993 127.998 389.809 136.929C380.732 145.966 367.597 150.378 350.403 150.378Z",
    fill: "url(#paint7_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.539 150.378C468.271 150.378 452.613 144.558 441.568 132.919C430.522 121.281 425.053 105.547 425.053 85.6103V84.2093C425.053 65.1348 430.951 49.5087 442.855 37.4389C454.758 25.3691 469.772 19.3343 487.896 19.3343C503.66 19.3343 516.636 23.2138 526.717 31.0807C536.798 38.9476 542.589 50.3708 543.983 65.5658H514.599C512.454 49.9398 503.66 42.0729 488.003 42.0729C477.922 42.0729 469.987 45.8447 464.088 53.2805C458.19 60.7164 455.295 70.9541 455.295 83.9938V85.3947C455.295 98.5422 458.19 108.78 463.981 116.108C469.772 123.436 477.815 126.992 488.217 126.992C496.261 126.992 502.802 124.945 507.842 120.85C512.883 116.755 515.993 110.72 517.172 102.637H545.27C543.768 118.048 537.87 129.794 527.682 137.984C517.601 146.282 504.518 150.378 488.539 150.378Z",
    fill: "url(#paint8_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.737 149.303V21.6988H595.483V76.6337L639.84 21.4825H670.416L620.245 82.0406L673 149.303H639.409L595.483 91.9895V149.303H566.737Z",
    fill: "url(#paint9_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.426 148.229V21.4825H225.2V125.673H276.928V148.229H196.426Z",
    fill: "url(#paint10_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6998 0V100.658H93.7442V0H76.6998Z",
    fill: "url(#paint11_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.266 35.4793C122.126 42.5352 136.355 61.574 136.355 83.9533L102.266 83.9538V35.4793Z",
    fill: "url(#paint12_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1777 35.4794C48.3176 42.5354 34.0888 61.5741 34.0888 83.9535C34.0888 106.333 48.3176 125.372 68.1777 132.428V35.4794Z",
    fill: "url(#paint13_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1219 21.9554C41.1632 29.4739 21.3681 54.4043 21.3681 84.0001C21.3681 119.548 49.9253 148.365 85.1523 148.365C108.07 148.365 128.165 136.168 139.41 117.856L108.995 117.856V100.714L168.686 100.714C160.962 140.05 126.498 169.712 85.1523 169.712C38.124 169.712 0 131.337 0 84.0001C0 42.5335 29.2542 7.94454 68.1219 0.00300492V21.9554Z",
    fill: "url(#paint14_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.984 72.8581C143.735 48.2896 125.68 28.5086 102.183 21.9555V0.00300737C137.511 7.22137 164.897 36.455 169.592 72.8581H147.984Z",
    fill: "url(#paint15_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 182.891H224.64V184.569H216.848V190.311H223.129V191.989H216.848V198.11H225.065V199.787H214.793V182.891Z",
    fill: "url(#paint16_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.514 200C255.42 200 253.862 199.512 252.838 198.535C251.831 197.542 251.241 196.243 251.067 194.636H253.051C253.13 195.187 253.24 195.668 253.382 196.077C253.539 196.487 253.775 196.873 254.09 197.235C254.421 197.598 254.869 197.873 255.436 198.062C256.003 198.251 256.695 198.346 257.514 198.346C258.616 198.346 259.529 198.054 260.253 197.472C260.993 196.873 261.363 196.101 261.363 195.156C261.363 194.179 261.072 193.454 260.489 192.982C259.923 192.509 258.852 192.155 257.278 191.918C255.373 191.619 253.956 191.131 253.027 190.453C252.099 189.76 251.634 188.697 251.634 187.263C251.634 185.955 252.146 184.868 253.169 184.002C254.192 183.12 255.491 182.679 257.065 182.679C258.766 182.679 260.112 183.08 261.103 183.884C262.111 184.672 262.701 185.822 262.874 187.334H261.033C260.828 186.263 260.411 185.499 259.781 185.042C259.167 184.569 258.262 184.333 257.065 184.333C255.932 184.333 255.058 184.585 254.444 185.089C253.846 185.577 253.547 186.239 253.547 187.074C253.547 187.956 253.814 188.626 254.35 189.083C254.885 189.524 255.971 189.862 257.608 190.099C259.592 190.398 261.04 190.918 261.953 191.658C262.882 192.383 263.347 193.502 263.347 195.014C263.347 196.432 262.788 197.621 261.67 198.582C260.568 199.527 259.183 200 257.514 200Z",
    fill: "url(#paint17_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.755 182.891H295.548C297.28 182.891 298.697 183.301 299.799 184.12C300.901 184.924 301.452 186.16 301.452 187.83V187.925C301.452 189.626 300.901 190.886 299.799 191.706C298.713 192.509 297.296 192.911 295.548 192.911H292.809V199.787H290.755V182.891ZM295.69 191.28C296.902 191.28 297.823 190.997 298.453 190.43C299.083 189.847 299.398 189.012 299.398 187.925V187.83C299.398 185.64 298.162 184.545 295.69 184.545H292.809V191.28H295.69Z",
    fill: "url(#paint18_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.9 198.299C337.757 198.299 339.229 197.661 340.315 196.384C341.417 195.108 341.968 193.439 341.968 191.375V191.186C341.968 189.232 341.417 187.602 340.315 186.294C339.213 184.987 337.726 184.333 335.852 184.333C333.932 184.333 332.42 184.971 331.318 186.247C330.216 187.507 329.665 189.169 329.665 191.233V191.422C329.665 193.439 330.256 195.093 331.436 196.384C332.633 197.661 334.121 198.299 335.9 198.299ZM335.9 200C333.444 200 331.436 199.181 329.878 197.542C328.319 195.888 327.54 193.856 327.54 191.446V191.257C327.54 188.815 328.311 186.775 329.854 185.136C331.413 183.498 333.412 182.679 335.852 182.679C338.292 182.679 340.276 183.498 341.803 185.136C343.33 186.759 344.094 188.783 344.094 191.209V191.398C344.094 193.824 343.33 195.865 341.803 197.519C340.276 199.173 338.308 200 335.9 200Z",
    fill: "url(#paint19_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.421 182.891H376.498C378.245 182.891 379.662 183.277 380.748 184.049C381.85 184.821 382.401 186.003 382.401 187.594V187.688C382.401 188.996 382.016 190.036 381.244 190.808C380.473 191.564 379.465 192.06 378.222 192.296L383.393 199.787H381.102L376.073 192.438H373.475V199.787H371.421V182.891ZM376.639 190.808C379.111 190.808 380.347 189.768 380.347 187.688V187.594C380.347 186.491 380.032 185.711 379.402 185.254C378.773 184.782 377.852 184.545 376.639 184.545H373.475V190.808H376.639Z",
    fill: "url(#paint20_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.265 184.569H408.353V182.891H420.231V184.569H415.319V199.787H413.265V184.569Z",
    fill: "url(#paint21_linear_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.053 200C449.959 200 448.401 199.512 447.378 198.535C446.37 197.542 445.78 196.243 445.606 194.636H447.59C447.669 195.187 447.779 195.668 447.921 196.077C448.078 196.487 448.314 196.873 448.629 197.235C448.96 197.598 449.408 197.873 449.975 198.062C450.542 198.251 451.234 198.346 452.053 198.346C453.155 198.346 454.068 198.054 454.792 197.472C455.532 196.873 455.902 196.101 455.902 195.156C455.902 194.179 455.611 193.454 455.028 192.982C454.462 192.509 453.391 192.155 451.817 191.918C449.912 191.619 448.495 191.131 447.566 190.453C446.638 189.76 446.173 188.697 446.173 187.263C446.173 185.955 446.685 184.868 447.708 184.002C448.731 183.12 450.03 182.679 451.604 182.679C453.305 182.679 454.651 183.08 455.642 183.884C456.65 184.672 457.24 185.822 457.413 187.334H455.572C455.367 186.263 454.95 185.499 454.32 185.042C453.706 184.569 452.801 184.333 451.604 184.333C450.471 184.333 449.597 184.585 448.983 185.089C448.385 185.577 448.086 186.239 448.086 187.074C448.086 187.956 448.354 188.626 448.889 189.083C449.424 189.524 450.51 189.862 452.148 190.099C454.131 190.398 455.579 190.918 456.492 191.658C457.421 192.383 457.886 193.502 457.886 195.014C457.886 196.432 457.327 197.621 456.209 198.582C455.107 199.527 453.722 200 452.053 200Z",
    fill: "url(#paint22_linear_253_1252)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_253_1252)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_253_1252",
    maskUnits: "userSpaceOnUse",
    x: 213.793,
    y: 181.679,
    width: 246,
    height: 20,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 213.793,
    y: 181.679,
    width: 246,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 182.891H224.64V184.569H216.848V190.311H223.129V191.989H216.848V198.11H225.065V199.787H214.793V182.891Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.514 200C255.42 200 253.862 199.512 252.838 198.535C251.831 197.542 251.24 196.243 251.067 194.636H253.051C253.13 195.187 253.24 195.668 253.381 196.077C253.539 196.487 253.775 196.873 254.09 197.235C254.421 197.598 254.869 197.873 255.436 198.062C256.003 198.251 256.695 198.346 257.514 198.346C258.616 198.346 259.529 198.054 260.253 197.471C260.993 196.873 261.363 196.101 261.363 195.156C261.363 194.179 261.072 193.454 260.489 192.982C259.923 192.509 258.852 192.155 257.278 191.918C255.373 191.619 253.956 191.131 253.027 190.453C252.098 189.76 251.634 188.697 251.634 187.263C251.634 185.955 252.146 184.868 253.169 184.002C254.192 183.12 255.491 182.679 257.065 182.679C258.766 182.679 260.111 183.08 261.103 183.884C262.111 184.671 262.701 185.822 262.874 187.334H261.032C260.828 186.263 260.411 185.499 259.781 185.042C259.167 184.569 258.262 184.333 257.065 184.333C255.932 184.333 255.058 184.585 254.444 185.089C253.846 185.577 253.547 186.239 253.547 187.074C253.547 187.956 253.814 188.626 254.35 189.083C254.885 189.524 255.971 189.862 257.608 190.099C259.592 190.398 261.04 190.918 261.953 191.658C262.882 192.383 263.347 193.502 263.347 195.014C263.347 196.432 262.788 197.621 261.67 198.582C260.568 199.527 259.183 200 257.514 200Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.755 182.891H295.548C297.28 182.891 298.697 183.301 299.799 184.12C300.901 184.924 301.452 186.16 301.452 187.83V187.925C301.452 189.626 300.901 190.886 299.799 191.706C298.713 192.509 297.296 192.911 295.548 192.911H292.809V199.787H290.755V182.891ZM295.69 191.28C296.902 191.28 297.823 190.997 298.453 190.43C299.083 189.847 299.398 189.012 299.398 187.925V187.83C299.398 185.64 298.162 184.545 295.69 184.545H292.809V191.28H295.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.899 198.299C337.757 198.299 339.229 197.661 340.315 196.384C341.417 195.108 341.968 193.439 341.968 191.375V191.186C341.968 189.232 341.417 187.602 340.315 186.294C339.213 184.987 337.726 184.333 335.852 184.333C333.932 184.333 332.42 184.971 331.318 186.247C330.216 187.507 329.665 189.169 329.665 191.233V191.422C329.665 193.439 330.256 195.093 331.436 196.384C332.633 197.661 334.121 198.299 335.899 198.299ZM335.899 200C333.444 200 331.436 199.181 329.878 197.542C328.319 195.888 327.54 193.856 327.54 191.446V191.257C327.54 188.815 328.311 186.775 329.854 185.136C331.413 183.498 333.412 182.679 335.852 182.679C338.292 182.679 340.276 183.498 341.803 185.136C343.33 186.759 344.094 188.783 344.094 191.209V191.398C344.094 193.824 343.33 195.865 341.803 197.519C340.276 199.173 338.308 200 335.899 200Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.421 182.891H376.498C378.245 182.891 379.662 183.277 380.748 184.049C381.85 184.821 382.401 186.003 382.401 187.594V187.688C382.401 188.996 382.016 190.036 381.244 190.808C380.473 191.564 379.465 192.06 378.221 192.296L383.393 199.787H381.102L376.073 192.438H373.475V199.787H371.421V182.891ZM376.639 190.808C379.111 190.808 380.347 189.768 380.347 187.688V187.594C380.347 186.491 380.032 185.711 379.402 185.254C378.773 184.782 377.852 184.545 376.639 184.545H373.475V190.808H376.639Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.265 184.569H408.353V182.891H420.231V184.569H415.319V199.787H413.265V184.569Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.053 200C449.959 200 448.401 199.512 447.377 198.535C446.37 197.542 445.78 196.243 445.606 194.636H447.59C447.669 195.187 447.779 195.668 447.921 196.077C448.078 196.487 448.314 196.873 448.629 197.235C448.96 197.598 449.408 197.873 449.975 198.062C450.542 198.251 451.234 198.346 452.053 198.346C453.155 198.346 454.068 198.054 454.792 197.471C455.532 196.873 455.902 196.101 455.902 195.156C455.902 194.179 455.611 193.454 455.028 192.982C454.462 192.509 453.391 192.155 451.817 191.918C449.912 191.619 448.495 191.131 447.566 190.453C446.638 189.76 446.173 188.697 446.173 187.263C446.173 185.955 446.685 184.868 447.708 184.002C448.731 183.12 450.03 182.679 451.604 182.679C453.305 182.679 454.651 183.08 455.642 183.884C456.65 184.671 457.24 185.822 457.413 187.334H455.572C455.367 186.263 454.95 185.499 454.32 185.042C453.706 184.569 452.801 184.333 451.604 184.333C450.471 184.333 449.597 184.585 448.983 185.089C448.385 185.577 448.086 186.239 448.086 187.074C448.086 187.956 448.353 188.626 448.889 189.083C449.424 189.524 450.51 189.862 452.147 190.099C454.131 190.398 455.579 190.918 456.492 191.658C457.421 192.383 457.886 193.502 457.886 195.014C457.886 196.432 457.327 197.621 456.209 198.582C455.107 199.527 453.722 200 452.053 200Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.793 182.891H224.64V184.569H216.848V190.311H223.129V191.989H216.848V198.11H225.065V199.787H214.793V182.891Z",
    stroke: "url(#paint23_linear_253_1252)",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.514 200C255.42 200 253.862 199.512 252.838 198.535C251.831 197.542 251.24 196.243 251.067 194.636H253.051C253.13 195.187 253.24 195.668 253.381 196.077C253.539 196.487 253.775 196.873 254.09 197.235C254.421 197.598 254.869 197.873 255.436 198.062C256.003 198.251 256.695 198.346 257.514 198.346C258.616 198.346 259.529 198.054 260.253 197.471C260.993 196.873 261.363 196.101 261.363 195.156C261.363 194.179 261.072 193.454 260.489 192.982C259.923 192.509 258.852 192.155 257.278 191.918C255.373 191.619 253.956 191.131 253.027 190.453C252.098 189.76 251.634 188.697 251.634 187.263C251.634 185.955 252.146 184.868 253.169 184.002C254.192 183.12 255.491 182.679 257.065 182.679C258.766 182.679 260.111 183.08 261.103 183.884C262.111 184.671 262.701 185.822 262.874 187.334H261.032C260.828 186.263 260.411 185.499 259.781 185.042C259.167 184.569 258.262 184.333 257.065 184.333C255.932 184.333 255.058 184.585 254.444 185.089C253.846 185.577 253.547 186.239 253.547 187.074C253.547 187.956 253.814 188.626 254.35 189.083C254.885 189.524 255.971 189.862 257.608 190.099C259.592 190.398 261.04 190.918 261.953 191.658C262.882 192.383 263.347 193.502 263.347 195.014C263.347 196.432 262.788 197.621 261.67 198.582C260.568 199.527 259.183 200 257.514 200Z",
    stroke: "url(#paint24_linear_253_1252)",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.755 182.891H295.548C297.28 182.891 298.697 183.301 299.799 184.12C300.901 184.924 301.452 186.16 301.452 187.83V187.925C301.452 189.626 300.901 190.886 299.799 191.706C298.713 192.509 297.296 192.911 295.548 192.911H292.809V199.787H290.755V182.891ZM295.69 191.28C296.902 191.28 297.823 190.997 298.453 190.43C299.083 189.847 299.398 189.012 299.398 187.925V187.83C299.398 185.64 298.162 184.545 295.69 184.545H292.809V191.28H295.69Z",
    stroke: "url(#paint25_linear_253_1252)",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.899 198.299C337.757 198.299 339.229 197.661 340.315 196.384C341.417 195.108 341.968 193.439 341.968 191.375V191.186C341.968 189.232 341.417 187.602 340.315 186.294C339.213 184.987 337.726 184.333 335.852 184.333C333.932 184.333 332.42 184.971 331.318 186.247C330.216 187.507 329.665 189.169 329.665 191.233V191.422C329.665 193.439 330.256 195.093 331.436 196.384C332.633 197.661 334.121 198.299 335.899 198.299ZM335.899 200C333.444 200 331.436 199.181 329.878 197.542C328.319 195.888 327.54 193.856 327.54 191.446V191.257C327.54 188.815 328.311 186.775 329.854 185.136C331.413 183.498 333.412 182.679 335.852 182.679C338.292 182.679 340.276 183.498 341.803 185.136C343.33 186.759 344.094 188.783 344.094 191.209V191.398C344.094 193.824 343.33 195.865 341.803 197.519C340.276 199.173 338.308 200 335.899 200Z",
    stroke: "url(#paint26_linear_253_1252)",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.421 182.891H376.498C378.245 182.891 379.662 183.277 380.748 184.049C381.85 184.821 382.401 186.003 382.401 187.594V187.688C382.401 188.996 382.016 190.036 381.244 190.808C380.473 191.564 379.465 192.06 378.221 192.296L383.393 199.787H381.102L376.073 192.438H373.475V199.787H371.421V182.891ZM376.639 190.808C379.111 190.808 380.347 189.768 380.347 187.688V187.594C380.347 186.491 380.032 185.711 379.402 185.254C378.773 184.782 377.852 184.545 376.639 184.545H373.475V190.808H376.639Z",
    stroke: "url(#paint27_linear_253_1252)",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.265 184.569H408.353V182.891H420.231V184.569H415.319V199.787H413.265V184.569Z",
    stroke: "url(#paint28_linear_253_1252)",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_253_1252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.053 200C449.959 200 448.401 199.512 447.377 198.535C446.37 197.542 445.78 196.243 445.606 194.636H447.59C447.669 195.187 447.779 195.668 447.921 196.077C448.078 196.487 448.314 196.873 448.629 197.235C448.96 197.598 449.408 197.873 449.975 198.062C450.542 198.251 451.234 198.346 452.053 198.346C453.155 198.346 454.068 198.054 454.792 197.471C455.532 196.873 455.902 196.101 455.902 195.156C455.902 194.179 455.611 193.454 455.028 192.982C454.462 192.509 453.391 192.155 451.817 191.918C449.912 191.619 448.495 191.131 447.566 190.453C446.638 189.76 446.173 188.697 446.173 187.263C446.173 185.955 446.685 184.868 447.708 184.002C448.731 183.12 450.03 182.679 451.604 182.679C453.305 182.679 454.651 183.08 455.642 183.884C456.65 184.671 457.24 185.822 457.413 187.334H455.572C455.367 186.263 454.95 185.499 454.32 185.042C453.706 184.569 452.801 184.333 451.604 184.333C450.471 184.333 449.597 184.585 448.983 185.089C448.385 185.577 448.086 186.239 448.086 187.074C448.086 187.956 448.353 188.626 448.889 189.083C449.424 189.524 450.51 189.862 452.147 190.099C454.131 190.398 455.579 190.918 456.492 191.658C457.421 192.383 457.886 193.502 457.886 195.014C457.886 196.432 457.327 197.621 456.209 198.582C455.107 199.527 453.722 200 452.053 200Z",
    stroke: "url(#paint29_linear_253_1252)",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_253_1252)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_253_1252",
    x: 0,
    y: 0,
    width: 673,
    height: 203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_253_1252"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_253_1252",
    x: 213.793,
    y: 181.679,
    width: 245.093,
    height: 22.3214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_253_1252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0260059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0260059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0260059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0260059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0260059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0260059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_253_1252",
    x1: 381.138,
    y1: 202.015,
    x2: 381.138,
    y2: -0.0260059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSiteFull);
export default __webpack_public_path__ + "static/media/logo-site-full.3279a44486d5e747d488ae336ab3ad4c.svg";
export { ForwardRef as ReactComponent };